import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      backgroundColor: '#ffffff',
      color: theme.palette.secondary.main,
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.grey[300],
      '& .MuiToolbar-gutters': {
        paddingLeft: theme.spacing(2)
      }
    },
    menuButton: {
      marginRight: theme.spacing(2),
      '&:focus': {
        outline: 'none'
      }
    },
    logo: {
      width: `${theme.logo.width}px`,
      height: `${theme.logo.height}px`,
      backgroundImage: `url(${theme.logo.base64})`,
      backgroundSize: `${theme.logo.width}px ${theme.logo.height}px`
    },
    grow: {
      flexGrow: 1
    },
    backToClassicLink: {
      '&:hover': {
        textDecoration: 'none',
        color: theme.palette.text.primary
      },
      textDecoration: 'none',
      color: theme.palette.text.primary
    }
  });
